module.exports = __webpack_public_path__ + "static/media/maui-mobile@3x.5ee8ca1d.png";